import { DatePipe, NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { UserOrderDetailsPanel } from '../../../components/account/user-order-details-panel/user-order-details-panel';
import { UserOrderListItem } from '../../../components/account/user-order-list-item/user-order-list-item';
import { Price } from '../../../components/common/price/price';
import { UserOrder } from '../../../models/shopping';
import { AccountApiService } from '../../../services/apis/account-api.service';
import { TitleService } from '../../../services/title.service';
@Component({
  selector: 'app-account-orders-page',
  imports: [
    UserOrderListItem,
    NgClass,
    MatPaginatorModule,
    MatExpansionModule,
    NzEmptyModule,
    DatePipe,
    UserOrderDetailsPanel,
    Price,
  ],
  templateUrl: './account-orders-page.html',
  styleUrl: './account-orders-page.scss',
})
export class AccountOrdersPage implements OnInit {
  activeOrder?: UserOrder;
  constructor(
    private titleService: TitleService,
    private accountApi: AccountApiService
  ) {
    this.titleService.setTitle('My Orders');
  }

  ngOnInit(): void {
    this.findUserOrders();
  }

  onOrderClick(order: UserOrder) {
    this.activeOrder = order;
  }

  onPageChanged(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.findUserOrders();
  }

  loading: boolean = false;
  orders: UserOrder[] = [];
  page: number = 1;
  pageSize: number = 10;
  total: number = 0;
  async findUserOrders() {
    try {
      this.loading = true;
      const r = await this.accountApi.findUserOrders({
        page: this.page,
        page_size: this.pageSize,
      });
      this.orders = r.items;
      this.total = r.total;
      this.page = r.page;
      this.pageSize = r.page_size;
      this.activeOrder = this.orders[0] ?? undefined;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
